import React, { useState, useEffect } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Modal from '@mui/material/Modal';
import useExternalBanner from 'hooks/useExternalBanner';
import { usePromoBanner } from 'hooks/useHeaderHeight';

import HeaderLogo from '../HeaderLogo';
import RightMenu from './RightMenu';

import ParentNav from './ParentNav';
import ChildNav from './ChildNav';

import './styles.less';

const Mobile = ({ navigationMenu, logoProps, rightMenuProps }) => {
  const [selectedSubMenu, setSelectedSubMenu] = useState([]);
  const [anim, toggleAnim] = useState(false);
  const [modalTop, setModalTop] = useState(0);
  const { isMobileMenuOpened, setMobileMenuOpened } = rightMenuProps;
  const bannerHeight = useExternalBanner();
  const promoHeight = usePromoBanner(true);

  const navClass = anim && isMobileMenuOpened ? 'open-child-nav' : 'open-parent-nav';

  useEffect(() => {
    toggleAnim(false);
  }, [isMobileMenuOpened]);

  useEffect(() => {
    setModalTop(`${bannerHeight + promoHeight + 80}px`);
  }, [bannerHeight, promoHeight]);

  const handleSubMenu = (subMenu) => {
    const modal = document.getElementById('mobile-header-modal');
    if (modal) {
      modal.scrollTop = 0;
    }
    setSelectedSubMenu(subMenu);
    toggleAnim(true);
  };

  return (
    <div className="mobile-header">
      <HeaderLogo {...logoProps} className={navClass} />

      <div
        className={`mobile-child-nav--back ${navClass}`}
        role="button"
        tabIndex={0} // Allows the element to receive keyboard focus
        onClick={() => toggleAnim(false)}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleAnim(false);
          }
        }}
      >
        <ArrowBackIosIcon />
        <p>
          <b>Back</b>
        </p>
      </div>

      <Modal
        id="mobile-header-modal"
        className={`mobile-header-modal ${navClass}`}
        open={isMobileMenuOpened}
        hideBackdrop
        style={{ top: modalTop }}
      >
        <div className="mobile-header-modal--inner-container">
          <ParentNav navigationMenu={navigationMenu} handleSubMenu={handleSubMenu} />
          <ChildNav selectedSubMenu={selectedSubMenu} setMobileMenuOpened={setMobileMenuOpened} />
        </div>
      </Modal>

      <RightMenu {...rightMenuProps} />
    </div>
  );
};

export default Mobile;
